'use client';

import React, { useEffect, useState } from 'react';
import { useSearchParams, usePathname } from 'next/navigation';
import { OrderConfirmation } from '@rich-products-corp/cc-custom-components/dist/components/PageSections/Ecommerce/checkout/order-confirmation';
import { CheckoutRegisterForm } from 'components/commercetools-ui/checkout/order-confirmation/CheckoutFasterForm';
import { getOrderByNumber } from 'frontastic/actions/order';
import { useAccount } from 'frontastic/provider';
import { pushToDataLayer, ANALYTICS_EVENTS, DataLayerObject } from 'frontastic/lib/utils/analytics-data-layer';

export const ThankYou = (props) => {
  const { shipSpeedData, bypassVerification } = props.data;

  const { loggedIn } = useAccount();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const orderNumber = searchParams.get('order');
  const [order, setOrder] = useState<any>(null);

  useEffect(() => {
    if (pathname.includes('thank-you') && orderNumber && order) {
      window['cc_data_layer'].orderData = order;
    }
  }, [pathname, order]);

  useEffect(() => {
    getOrderByNumber(orderNumber as string)
      .then((result) => {
        setOrder(result);
        const orderLineItems = result?.lineItems?.map((lineItem) => {
          return {
            page_id: lineItem?.variant?.attributes?.PowerReviews_PageID,
            page_id_variant: lineItem?.variant?.sku,
            product_name: lineItem?.name,
            quantity: lineItem?.count,
            unit_price: lineItem?.price?.centAmount / 100,
          };
        });
        window['cc_data_layer'] = {
          order: {
            userEmail: result?.email,
            userFirstName: result?.billingAddress?.firstName,
            userLastName: result?.billingAddress?.lastName,
            orderId: result?.orderId,
            orderItems: orderLineItems,
          },
          ecommerce: {
            currency: result?.sum?.currencyCode,
            value: result?.sum?.centAmount / 100.0,
            transaction_id: result.cartId || result.orderId || result.orderNumber,
            customer_id: result.email,
            customer_email: result.email,
            purchase: {
              items: result.lineItems.map((product) => ({
                item_id: product.variant.sku ? product.variant.sku : product.productId,
                item_name: product.name,
                item_variant: product.variant?.attributes?.tin_color?.label,
                coupon: product.discounts?.[0]?.code,
                discount: (product.price.centAmount - product.discountedPrice?.centAmount) / 100.0,
                price: product.price.centAmount / 100.0,
                quantity: product.count,
              })),
            },
            fullOrder: result,
          },
        };

        const dataLayerObject: DataLayerObject = {
          event: ANALYTICS_EVENTS.PURCHASE,
          ecommerce: {
            transaction_id: result.cartId || result.orderId || result.orderNumber,
          },
        };
        pushToDataLayer(dataLayerObject);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [orderNumber]);

  if (!order) {
    return <></>;
  }

  if (order && order.shippingInfo) {
    for (let i = 0; i < order.shippingInfo.length; i++) {
      order.shippingInfo[i].shippingInfo.giftMessage = order.shippingInfo[i].shippingInfo.giftMessage
        ? order.shippingInfo[i].shippingInfo.giftMessage.trim()
        : '';
      const discountedShippingPrice = order.shippingInfo[i].shippingInfo.discountedPrice?.value;
      if (discountedShippingPrice?.centAmount) {
        order.shippingInfo[i].shippingInfo.price = discountedShippingPrice;
      }
    }
  }

  return (
    <div className="mx-6 mt-8 lg:mx-28 lg:mt-20">
      <OrderConfirmation
        orderId={order.orderId}
        email={order.email}
        paymentType={{
          cardNumber: order.payments[0]?.paymentType,
        }}
        billingAddress={{
          addressId: order.billingAddress?.addressId,
          firstName: order.billingAddress?.firstName,
          lastName: order.billingAddress?.lastName,
          streetName: order.billingAddress?.streetName,
          city: order.billingAddress?.city,
          state: order.billingAddress?.state,
          country: order.billingAddress?.country,
          postalCode: order.billingAddress?.postalCode,
          additionalAddressInfo: order.billingAddress?.additionalAddressInfo,
          apartment: order.billingAddress?.additionalAddressInfo ?? '',
          companyName: order.billingAddress?.companyName ?? '',
        }}
        shippingAddress={order.shippingAddress}
        shippingInfo={order.shippingInfo}
        lineItems={order.lineItems}
        itemSubtotal={order.itemSubtotal}
        discountedCodes={{
          code: order.discountCodes[0]?.code,
          name: order.discountCodes[0]?.name,
          discountedAmount: order.discountCodes[0]?.discountedAmount,
        }}
        sum={order.sum}
        shipSpeedData={shipSpeedData}
        taxed={order.taxed}
        taxedPrice={order.taxedPrice}
      />
      {!loggedIn && <CheckoutRegisterForm order={order} bypassVerification={bypassVerification} />}
    </div>
  );
};